import { AdvertiserListComponent } from '../advertiser-list/advertiser-list.component';
import { CampaignSheetComponent } from './components/campaign-sheet/campaign-sheet.component';
import { BrandSheetComponent } from './components/brand-sheet/brand-sheet.component';
import { CompanyListComponent } from './components/company-list/company-list.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppCommonModule } from 'src/app/common/common.module';
import { CampaignAdapter } from '../../../../adapters/campaign-adapter';
import { TimezonePipe } from 'src/app/common/pipes/timezone.pipe';

const components = [
    CompanyListComponent,
    BrandSheetComponent,
    CampaignSheetComponent,
    AdvertiserListComponent
];

@NgModule({
    declarations: components,
    providers: [CampaignAdapter, TimezonePipe],
    imports: [
        CommonModule,
        AppCommonModule
    ],
    exports: components
})
export class CompanyListModule {
}
